"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _color = _interopRequireDefault(require("color"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const OwnerIcon = ({
  className,
  defaultColor = "#000",
  color,
  label,
  theme,
  title,
  abbr
}) => {
  let fill = color || theme && theme.primaryColor || defaultColor;
  let text = label || abbr || title && title.substr(0, 3).toUpperCase();
  fill = (0, _color.default)(fill);
  let contrast;

  if (fill.isDark()) {
    contrast = 'white';
  } else {
    contrast = 'black';
  }

  return _react.default.createElement(_SvgIcon.default, {
    className: className,
    title: title
  }, _react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: fill
  }), _react.default.createElement("text", {
    x: "12",
    y: "12.75",
    fill: contrast,
    fontFamily: "Akkurat, sans-serif",
    fontSize: "9",
    fontWeight: "normal",
    dominantBaseline: "middle",
    textAnchor: "middle"
  }, text));
};

var _default = OwnerIcon;
exports.default = _default;
module.exports = exports.default;